<template>
  <div class="md-layout" id="version">
    <div class="md-layout-item md-small-size-100">
      <div class="text-right">
        <md-button @click="goBack" class="md-primary md-dense">
          Back to List
        </md-button>
      </div>
      <form @submit.prevent="update" novalidate>
        <nav-tabs-card>
          <template slot="content">
            <md-tabs class="md-rose" md-alignment="left">
              <md-tab id="tab-home" md-label="Info" md-icon="timeline">
                <div
                  id="info-tab-1"
                  class="md-layout-item md-size-50 md-small-size-100"
                >
                  <md-card>
                    <md-card-header>
                      <h4 class="title">Informations</h4>
                    </md-card-header>
                    <md-card-content>
                      <div class="md-layout spacing">
                        <label class="md-layout-item md-size-15 md-form-label">
                          Name
                        </label>
                        <div class="md-layout-item">
                          <md-field class="md-invalid">
                            <md-input v-model="version.name" />
                            <validation-error
                              :errors="apiValidationErrors.name"
                            />
                          </md-field>
                        </div>
                      </div>

                      <div class="md-layout spacing">
                        <label class="md-layout-item md-size-15 md-form-label">
                          Work
                        </label>
                        <div class="md-layout-item">
                          <multiselect
                            v-model="selectedWork"
                            id="work"
                            label="name"
                            track-by="id"
                            placeholder="Type to search"
                            open-direction="bottom"
                            :options="works"
                            :multiple="false"
                            :searchable="true"
                            :loading="isLoading"
                            :internal-search="false"
                            :clear-on-select="false"
                            :close-on-select="true"
                            :options-limit="300"
                            :limit="3"
                            :limit-text="limitText"
                            :max-height="600"
                            :show-no-results="false"
                            :hide-selected="false"
                            @search-change="getWorks"
                            @select="selectWork"
                          >
                          </multiselect>
                        </div>
                      </div>

                      <div class="md-layout spacing">
                        <label class="md-layout-item md-size-15 md-form-label">
                          Parent
                        </label>
                        <div class="md-layout-item">
                          <multiselect
                            v-model="selectedParent"
                            id="parent"
                            label="name"
                            track-by="id"
                            placeholder="Type to search"
                            open-direction="bottom"
                            :options="parents"
                            :multiple="false"
                            :searchable="true"
                            :loading="isLoading"
                            :internal-search="false"
                            :clear-on-select="false"
                            :close-on-select="true"
                            :options-limit="300"
                            :limit="3"
                            :limit-text="limitText"
                            :max-height="600"
                            :show-no-results="false"
                            :hide-selected="false"
                            @search-change="getParents"
                            @select="selectParent"
                            @remove="removeParent"
                          >
                          </multiselect>
                        </div>
                      </div>
                      <div class="md-layout spacing">
                        <label class="md-layout-item md-size-15 md-form-label">
                          Status
                        </label>
                        <div class="md-layout-item">
                          <md-radio v-model="version.status" value="PUBLISHED"
                            >Published</md-radio
                          >
                          <md-radio
                            v-model="version.status"
                            value="TO_BE_VALIDATED"
                            >To be validated</md-radio
                          >
                          <md-radio v-model="version.status" value="DRAFT"
                            >Draft</md-radio
                          >
                        </div>
                      </div>
                    </md-card-content>
                  </md-card>

                  <md-card>
                    <md-card-header>
                      <h4 class="title">Owners</h4>
                    </md-card-header>
                    <md-card-content>
                      <div class="md-layout spacing">
                        <label class="md-layout-item md-size-15 md-form-label">
                          Organization owners
                        </label>
                        <div class="md-layout-item">
                          <multiselect
                            :options="organization_options"
                            :value="organization_options_proxy"
                            @input="updateOrganizationSelected"
                            @search-change="searchOrganizationQuery"
                            :multiple="true"
                            :searchable="true"
                            :close-on-select="true"
                            placeholder="Search"
                            :custom-label="customLabel"
                            :loading="showOrganizationLoadingSpinner"
                          ></multiselect>

                          <div
                            class="resources-list"
                            v-for="(
                              resource, index
                            ) in selectedOrganizationResources"
                            v-bind:key="resource.id"
                          >
                            <md-card class="resource-item" :data-index="index">
                              <div class="resource-info">
                                <div class="resource-title" :id="index">
                                  <span>{{ resource.name }}</span>
                                  <!-- <span class="version">{{ resource.version }}</span> -->
                                </div>
                                <div class="resource-description">
                                  <span>{{ resource.description }}</span>
                                </div>
                                <div class="resource-url">
                                  <a :href="resource.latest" target="_blank">{{
                                    resource.latest
                                  }}</a>
                                </div>
                              </div>
                              <div
                                class="delete-controls"
                                v-on:click.prevent="
                                  removeOrganizationDependency(index)
                                "
                              >
                                <i class="fa fa-times fa-fw"></i>
                              </div>
                            </md-card>
                          </div>
                        </div>
                      </div>

                      <div class="md-layout spacing">
                        <label class="md-layout-item md-size-15 md-form-label">
                          User owners
                        </label>
                        <div class="md-layout-item">
                          <md-field>
                            <label>Select ...</label>
                            <md-select
                              v-model="version.parent"
                              name="parents"
                              @md-selected="onSelect"
                            >
                              <md-option
                                v-for="parent in available_parents"
                                :key="parent.id"
                                :value="parent.id"
                              >
                                {{ parent.name }}
                              </md-option>
                            </md-select>
                          </md-field>
                        </div>
                      </div>
                    </md-card-content>
                  </md-card>
                </div>
                <div
                  id="info-tab-2"
                  class="md-layout-item md-size-50 md-small-size-100"
                >
                  <md-card>
                    <md-card-header>
                      <h4 class="title">Media</h4>
                    </md-card-header>
                    <md-card-content>
                      <img
                        class="img"
                        :src="require('@/assets/images/video_placeholder.jpg')"
                      />
                    </md-card-content>
                  </md-card>

                  <md-card>
                    <md-card-header>
                      <h4 class="title">Place / Date</h4>
                    </md-card-header>
                    <md-card-content>
                      <div class="md-layout">
                        <label class="md-layout-item md-size-25 md-form-label">
                          Date
                        </label>
                        <div class="md-layout-item">
                          <md-datepicker
                            v-model="version.performance_date"
                            :md-model-type="String"
                            :class="{
                              'md-invalid':
                                !!apiValidationErrors.performance_date,
                            }"
                          >
                            <label>Select date ...</label>
                            <validation-error
                              :errors="apiValidationErrors.performance_date"
                            />
                          </md-datepicker>
                        </div>
                      </div>

                      <div class="md-layout spacing">
                        <label class="md-layout-item md-size-15 md-form-label">
                          Place
                        </label>
                        <div class="md-layout-item">
                          <md-field>
                            <label>Select ...</label>
                            <md-select
                              v-model="version.parent"
                              name="parents"
                              @md-selected="onSelect"
                            >
                              <md-option
                                v-for="parent in available_parents"
                                :key="parent.id"
                                :value="parent.id"
                              >
                                {{ parent.name }}
                              </md-option>
                            </md-select>
                          </md-field>
                        </div>
                      </div>
                    </md-card-content>
                  </md-card>
                </div>
              </md-tab>

              <md-tab
                id="tab-instructions"
                md-label="Instruction"
                md-icon="code"
              >
                <md-table @md-selected="onSelect">
                  <div class="md-layout spacing">
                    <div class="md-layout-item">
                      <editor
                        ref="toastuiEditor"
                        :initialValue="editorText"
                        initialEditType="markdown"
                        height="500px"
                        :options="editorOptions"
                        @load="onEditorLoad"
                        @change="onEditorChange"
                        @stateChange="onEditorStateChange"
                      />
                      <validation-error
                        :errors="apiValidationErrors.description"
                      />
                    </div>
                  </div>
                </md-table>
              </md-tab>

              <md-tab id="tab-softwares" md-label="Softwares" md-icon="widgets">
                <multiselect
                  :options="software_options"
                  :value="software_options_proxy"
                  @input="updateSoftwareSelected"
                  @search-change="searchSoftwareQuery"
                  :multiple="true"
                  :searchable="true"
                  :close-on-select="true"
                  placeholder="Search"
                  :custom-label="customLabel"
                  :loading="showSoftwareLoadingSpinner"
                ></multiselect>

                <div
                  class="resources-list"
                  v-for="(resource, index) in selectedSoftwareResources"
                  v-bind:key="resource.id"
                >
                  <md-card class="resource-item" :data-index="index">
                    <div class="resource-info">
                      <div class="resource-title" :id="index">
                        <span>{{ resource.name }}</span>
                        <!-- <span class="version">{{ resource.version }}</span> -->
                      </div>
                      <div class="resource-description">
                        <span>{{ resource.description }}</span>
                      </div>
                      <div class="resource-url">
                        <a :href="resource.latest" target="_blank">{{
                          resource.latest
                        }}</a>
                      </div>
                    </div>
                    <div
                      class="delete-controls"
                      v-on:click.prevent="removeSoftwareDependency(index)"
                    >
                      <i class="fa fa-times fa-fw"></i>
                    </div>
                  </md-card>
                </div>
              </md-tab>

              <md-tab
                id="tab-hardwares"
                md-label="Hardwares"
                md-icon="handyman"
              >
                <multiselect
                  :options="hardware_options"
                  :value="hardware_options_proxy"
                  @input="updateHardwareSelected"
                  @search-change="searchHardwareQuery"
                  :multiple="true"
                  :searchable="true"
                  :close-on-select="true"
                  placeholder="Search"
                  :custom-label="customLabel"
                  :loading="showHardwareLoadingSpinner"
                ></multiselect>

                <div
                  class="resources-list"
                  v-for="(resource, index) in selectedHardwareResources"
                  v-bind:key="resource.id"
                >
                  <md-card class="resource-item" :data-index="index">
                    <div class="resource-info">
                      <div class="resource-title" :id="index">
                        <span>{{ resource.name }}</span>
                        <!-- <span class="version">{{ resource.version }}</span> -->
                      </div>
                      <div class="resource-description">
                        <span>{{ resource.description }}</span>
                      </div>
                      <div class="resource-url">
                        <a :href="resource.latest" target="_blank">{{
                          resource.latest
                        }}</a>
                      </div>
                    </div>
                    <div
                      class="delete-controls"
                      v-on:click.prevent="removeHardwareDependency(index)"
                    >
                      <i class="fa fa-times fa-fw"></i>
                    </div>
                  </md-card>
                </div>
              </md-tab>

              <md-tab id="tab-files" md-label="Files" md-icon="file_copy">
                <md-table @md-selected="onSelect">
                  <!--UPLOAD-->
                  <div class="dropbox">
                    <input
                      type="file"
                      multiple
                      :name="uploadFieldName"
                      :disabled="isSaving"
                      @change="
                        filesChange($event.target.name, $event.target.files);
                        fileCount = $event.target.files.length;
                      "
                      class="input-file"
                    />
                    <p v-if="isInitial | isSuccess">
                      Drag your file(s) here to begin<br />
                      or click to browse
                    </p>
                    <p v-if="isSaving">Uploading {{ fileCount }} files...</p>
                  </div>

                  <!--SUCCESS-->
                  <div v-if="isSuccess | uploadedFilesLength">
                    <div v-bind:key="item.id" v-for="item in uploadedFiles">
                      <md-card>
                        <md-field>
                          <label>File</label>
                          <md-file v-model="item.name" />
                        </md-field>
                      </md-card>
                    </div>
                  </div>
                  <!--FAILED-->
                  <div v-if="isFailed">
                    <h2>Uploaded failed.</h2>
                    <p>
                      <a href="javascript:void(0)" @click="reset()"
                        >Try again</a
                      >
                    </p>
                    <pre>{{ uploadError }}</pre>
                  </div>
                </md-table>
              </md-tab>
            </md-tabs>
          </template>
        </nav-tabs-card>
        <md-card-actions md-alignment="right">
          <md-button type="submit" class="md-success">Update Item</md-button>
        </md-card-actions>
      </form>
    </div>
  </div>
</template>

<script>
import { ValidationError, NavTabsCard } from "@/components";
import Multiselect from "vue-multiselect";
import formMixin from "@/mixins/form-mixin";
import * as axios from "axios";
import "@toast-ui/editor/dist/toastui-editor.css";
import { Editor } from "@toast-ui/vue-editor";

const STATUS_INITIAL = 0,
  STATUS_SAVING = 1,
  STATUS_SUCCESS = 2,
  STATUS_FAILED = 3;

const initEditText = `# 1.  Audio setup
# 2.  Loudspeaker setup
# 3.  Midi setup
# 4.  Software installation
## a) Max/MSP patches
## b) Routing in Max/MSP
## c) DSP Status Options (Fs, IO vs, S vs, Overdrive, Audio Interrupt, Vector Optimization)
## d) XXX
# 5.  Patch presentation
## a) Notations
## b) Shortcuts
## c) Main patch
## d) Main sub-patch
## e) XXX
# 6.  Initialization routine
# 7.  System calibration and tests
# 8.  Performance notes`;

export default {
  components: {
    ValidationError,
    NavTabsCard,
    Multiselect,
    editor: Editor,
  },

  mixins: [formMixin],

  data() {
    return {
      version: {
        type: "Version",
        name: null,
        instruction: "",
        status: "DRAFT",
        work: {
          id: "",
          type: "Work",
        },
        parent_version: {
          id: "",
          type: "Version",
        },
        owner_organizations: [],
        performance_date: null,
        softwares: [],
        hardwares: [],
        relationshipNames: [
          "work",
          "parent_version",
          "owner_organizations",
          "files",
          "softwares",
          "hardwares",
        ],
      },
      // Instruction
      editorText: initEditText,
      editorOptions: {
        usageStatistics: false,
        hideModeSwitch: true,
        minHeight: "500px",
      },

      // work
      works: [],
      selectedWork: "",

      // parent
      parents: [],
      selectedParent: "",

      available_works: [],
      available_parents: [],

      // organizations
      organization_options: [],
      organization_options_proxy: [],
      selectedOrganizationResources: [],
      showOrganizationLoadingSpinner: false,

      // softwares
      software_options: [],
      software_options_proxy: [],
      selectedSoftwareResources: [],
      showSoftwareLoadingSpinner: false,

      // hardware
      hardware_options: [],
      hardware_options_proxy: [],
      selectedHardwareResources: [],
      showHardwareLoadingSpinner: false,

      // Files
      uploadedFiles: [],
      uploadError: null,
      currentStatus: null,
      uploadFieldName: "photos",
    };
  },
  mounted() {
    this.reset();
    this.$refs.toastuiEditor.editor.removeHook("addImageBlobHook");
    this.$refs.toastuiEditor.editor.addHook(
      "addImageBlobHook",
      this.uploadImage
    );
  },
  created() {
    this.get().then(() => {
      this.getSoftwares().then(() => this.initSoftwares());
      this.getHardwares().then(() => this.initHardwares());
      this.getOrganizations().then(() => this.initOrganizations());
      this.initFiles();
      this.$refs.toastuiEditor.invoke(
        "setMarkdown",
        this.version.instruction,
        false
      );
      this.$refs.toastuiEditor.invoke("moveCursorToStart");
      this.getWorks();
      this.getParents();
      this.uploadedFiles = this.version.files;
    });
  },
  computed: {
    isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED;
    },
    uploadedFilesLength() {
      if (this.uploadedFiles !== undefined) {
        return this.uploadedFiles.length;
      } else {
        return 0;
      }
    },
  },

  methods: {
    async get() {
      try {
        const id = this.$route.params.id;
        await this.$store.dispatch("versions/get", id);
        this.version = this.$store.getters["versions/version"];
        if (this.version.instruction)
          this.editorText = this.version.instruction;
      } catch (e) {
        await this.$store.dispatch(
          "alerts/error",
          "Oops, something went wrong!"
        );
      }
    },
    async update() {
      try {
        this.resetApiValidation();

        // Set Owner Organizations
        this.version.owner_organizations = [];
        this.selectedOrganizationResources.forEach((organization) => {
          this.version.owner_organizations.push({
            id: organization.id,
            type: "Organization",
          });
        });

        // Set Softwares
        this.version.softwares = [];
        this.selectedSoftwareResources.forEach((software) => {
          this.version.softwares.push({
            id: software.id,
            type: "Software",
          });
        });

        // Set Hardware
        this.version.hardwares = [];
        this.selectedHardwareResources.forEach((hardware) => {
          this.version.hardwares.push({
            id: hardware.id,
            type: "Hardware",
          });
        });

        await this.$store.dispatch("versions/update", this.version);

        // If update files
        // this.uploadedFiles.forEach(async (file) => {
        //   file.version = this.version.id;
        //   await this.$store.dispatch("files/update", file);
        // });

        await this.$store.dispatch(
          "alerts/success",
          "Item updated successfully."
        );

        this.goBack();
      } catch (e) {
        if (e.response.data.errors[0]) {
          await this.$store.dispatch(
            "alerts/error",
            e.response.data.errors[0].title
          );
          this.setApiValidation(e.response.data.errors);
        } else {
          await this.$store.dispatch(
            "alerts/error",
            "Oops, something went wrong!"
          );
          this.setApiValidation(e.response.data.errors);
        }
      }
    },
    // ******** INSTRUCTIONS ******** //
    async uploadImage(blob, callback) {
      let formData = new FormData();
      formData.append("file", blob);
      await this.$store.dispatch("images/add", formData);
      let imageUploaded = await this.$store.getters["images/image"];
      let file = imageUploaded.file;
      // @Todo : we should not replace
      file = await file.replace("minio1:9000", "localhost:9153");
      callback(file, "");
    },
    async onEditorLoad() {
      let editor = await this.$refs.toastuiEditor;
      let version = await this.version;
      await editor.invoke("setMarkdown", this.version.instruction, false);
    },
    onEditorChange() {
      this.saveMarkdown();
    },
    onEditorStateChange() {},
    saveMarkdown() {
      this.version.instruction = this.$refs.toastuiEditor.invoke("getMarkdown");
    },
    reset() {
      // reset form to initial state
      this.currentStatus = STATUS_INITIAL;
      this.uploadedFiles = [];
      this.uploadError = null;
    },
    // ******** FILES ******** //
    initFiles() {
      this.uploadedFiles = this.version.files;
    },
    async filesChange(fieldName, fileList) {
      if (!fileList.length) return;
      // upload each files
      await Array.from(Array(fileList.length).keys()).map(async (x) => {
        let formData = await new FormData();
        await formData.append("file", fileList[x], fileList[x].name);
        await this.upload(formData);
      });
      this.currentStatus = await STATUS_SUCCESS;
      await this.$store.dispatch("alerts/success", "File(s) saved !");
    },
    async upload(data) {
      try {
        this.currentStatus = STATUS_SAVING;
        await this.$store.dispatch("files/add", data);
        let file = await this.$store.getters["files/file"];
        this.uploadedFiles.push(file);

        await delete file.file;
        // file.version = this.version.id;
        file.version = await {
          id: this.version.id,
          type: "Version",
        };
        await this.$store.dispatch("files/update", file);
      } catch (e) {
        this.uploadError = err.response;
        this.currentStatus = STATUS_FAILED;
        await this.$store.dispatch(
          "alerts/error",
          "Oops, something went wrong!"
        );
      }
    },
    // ******** WORK ******** //
    getWorks(search) {
      let params = {
        filter: {
          ...(search ? { name: search } : {}),
        },
      };
      this.$store.dispatch("works/list", params).then(() => {
        this.works = this.$store.getters["works/dropdown"];
        if (this.selectedWork === "" && this.version.work.id) {
          this.selectedWork = this.works.filter((obj) => {
            return obj.id === this.version.work.id;
          });
        }
        this.isLoading = false;
      });
    },
    selectWork(option) {
      this.version.work = {
        id: option.id,
        type: "Work",
      };
    },
    // ******** PARENT ******** //
    getParents(search) {
      let params = {
        filter: {
          ...(search ? { name: search } : {}),
        },
      };
      this.$store.dispatch("versions/list", params).then(() => {
        this.parents = this.$store.getters["versions/dropdown"];

        if (this.version.parent_version) {
          if (
            this.selectedParents === undefined &&
            this.version.parent_version.id
          ) {
            this.selectedParent = this.parents.filter((obj) => {
              return obj.id === this.version.parent_version.id;
            })[0];
          }
        }
      });
      this.isLoading = false;
    },
    selectParent(option) {
      this.version.parent_version = {
        id: option.id,
        type: "Version",
      };
    },
    removeParent(removedOption) {
      this.version.parent_version = null;
    },
    goBack() {
      this.$router.push({ name: "List Versions" });
    },
    onSelect: function (items) {
      this.selected = items;
    },
    customLabel(option) {
      return `${option.name}`;
    },

    // ******** ORGANIZATIONS ******** //
    async getOrganizations(value) {
      await this.$store.dispatch("organizations/list").then(async () => {
        this.organization_options = [];
        this.organization_options = await this.$store.getters[
          "organizations/dropdown"
        ];
        this.showOrganizationLoadingSpinner = false;
      });
    },
    async initOrganizations() {
      // prefill form if data exists
      let version_organization_length = await this.version.owner_organizations
        .length;
      if (
        this.organization_options_proxy.length === 0 &&
        version_organization_length > 0
      ) {
        this.version.owner_organizations.forEach((objA) => {
          let s = this.organization_options.filter((objB) => {
            return objB.id === objA.id;
          });

          this.selectedOrganizationResources.push(s[0]);
        });
      }
    },
    searchOrganizationQuery(value) {
      this.showOrganizationLoadingSpinner = true;
      this.getOrganizations(value);
    },
    updateOrganizationSelected(value) {
      value.forEach((resource) => {
        // Adds selected resources to array
        this.selectedOrganizationResources.push(resource);
      });
      // Clears selected array
      this.organization_options_proxy = [];
    },
    removeOrganizationDependency(index) {
      this.selectedOrganizationResources.splice(index, 1);
    },

    // ******** SOFTWARES ******** //
    async getSoftwares(value) {
      await this.$store.dispatch("softwares/list").then(async () => {
        this.software_options = [];
        this.software_options = await this.$store.getters["softwares/dropdown"];
        this.showSoftwareLoadingSpinner = false;
      });
    },
    async initSoftwares() {
      // prefill form if data exists
      let version_software_length = await this.version.softwares.length;
      if (
        this.software_options_proxy.length === 0 &&
        version_software_length > 0
      ) {
        this.version.softwares.forEach((objA) => {
          let s = this.software_options.filter((objB) => {
            return objB.id === objA.id;
          });

          this.selectedSoftwareResources.push(s[0]);
        });
      }
    },
    searchSoftwareQuery(value) {
      this.showSoftwareLoadingSpinner = true;
      this.getSoftwares(value);
    },
    updateSoftwareSelected(value) {
      value.forEach((resource) => {
        // Adds selected resources to array
        this.selectedSoftwareResources.push(resource);
      });
      // Clears selected array
      this.software_options_proxy = [];
    },
    removeSoftwareDependency(index) {
      this.selectedSoftwareResources.splice(index, 1);
    },

    // ******** HARDWARES ******** //
    async initHardwares() {
      // prefill form if data exists
      let version_hardware_length = await this.version.hardwares.length;
      if (
        this.hardware_options_proxy.length === 0 &&
        version_hardware_length > 0
      ) {
        this.version.hardwares.forEach((objA) => {
          let s = this.hardware_options.filter((objB) => {
            return objB.id === objA.id;
          });

          this.selectedHardwareResources.push(s[0]);
        });
      }
    },
    async getHardwares(value) {
      await this.$store.dispatch("hardwares/list").then(async () => {
        this.hardware_options = [];
        this.hardware_options = await this.$store.getters["hardwares/dropdown"];
        this.showHardwareLoadingSpinner = false;
      });
    },
    searchHardwareQuery(value) {
      this.showHardwareLoadingSpinner = true;
      this.getHardwares(value);
    },
    updateHardwareSelected(value) {
      value.forEach((resource) => {
        // Adds selected resources to array
        this.selectedHardwareResources.push(resource);
      });
      // Clears selected array
      this.hardware_options_proxy = [];
    },
    removeHardwareDependency(index) {
      this.selectedHardwareResources.splice(index, 1);
    },
    limitText(count) {
      return `and ${count} other countries`;
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" scoped>
.spacing {
  padding-bottom: 1rem;
}

.md-inline-checkboxes {
  display: inline-flex;

  .md-checkbox {
    margin-top: 15px !important;
  }
}

.md-checkbox,
.md-radio {
  margin-top: 15px;
  margin-bottom: 0.5rem;
}

.md-checkbox,
.md-radio {
  display: flex;
}

.md-radio .md-radio-container {
  margin-left: 5px;
  position: relative;
  left: -3px;
}

.md-form-label + .md-layout-item .md-checkbox:not(:first-child),
.md-form-label + .md-layout-item + .md-layout-item .md-radio:not(:first-child),
.md-form-label + .md-layout-item .md-radio {
  margin-top: 0;
}

.md-field.md-has-textarea:not(.md-autogrow) .md-textarea {
  padding-left: 0;
  padding-top: 10px;
  min-height: 150px;
}

.md-field:after,
.md-field:before {
  bottom: 10px !important;
}

.dropbox {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  background: lightcyan;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px; /* minimum height */
  position: relative;
  cursor: pointer;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}

.dropbox:hover {
  background: lightblue; /* when mouse over to the drop zone, change color */
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}

iframe {
  height: 37vh;
}
</style>
